import React from "react";
import { images } from "../data/images";
import { useProcessedImage } from "../hooks/useProcessedImage";
import { cutOutSubject } from "../utils/imageProcessing";
const ALT = "Liftoff Investments (Pty) Ltd";

/**
 * The original logo uses charcoal artwork that matches the page background,
 * so it sits on a white plate to stay fully legible, exactly as designed.
 */
export function Logo() {
  const logo = useProcessedImage(images.logo, cutOutSubject);
  return <div className="inline-flex h-[68px] items-center justify-center overflow-hidden rounded-md bg-brand-white px-4 py-2.5 shadow-[0_10px_30px_rgba(0,0,0,0.35)] sm:h-[76px] lg:h-[96px] lg:px-5 lg:py-3" data-id="element-32" data-mp="rrxl8y4yyr8l">
      {logo.status === "ready" && <img src={logo.url} alt={ALT} className="h-full w-auto object-contain" data-id="element-33" data-mp="ht01e8ihnlvx" />}
      {logo.status === "error" && <img src={images.logo} alt={ALT} className="h-[180%] w-auto max-w-none object-contain" data-id="element-34" data-mp="2yhlz7vper5lt" />}
    </div>;
}